import React, { useCallback, useState } from 'react';
import { ChakraProvider } from '@chakra-ui/react';
import { AnimatePresence } from 'framer-motion';
import { useAppDispatch } from '../../../utils/reduxHooks';
import { sendCodeAction, setUserPhoneAction } from '../../../modules/auth/actions';
import {
  PhoneInputForm,
  CaptchaForm,
  CodeInputForm,
  NewPasswordForm,
} from '../../components/passwordRecoveryForms';

export const PasswordRecoveryPage = () => {
  const [step, setStep] = useState(1);
  const [phone, setPhone] = useState('');
  const dispatch = useAppDispatch();

  const handleNext = useCallback((nextStep: number, phoneNumber?: string) => {
    if (phoneNumber) {
      dispatch(setUserPhoneAction(phoneNumber));
      setPhone(phoneNumber);
    }
    setStep(nextStep);
  }, []);

  const sendCode = useCallback(() => {
    handleNext(3);
    dispatch(sendCodeAction.request(phone));
  }, [phone]);

  return (
    <ChakraProvider>
      <AnimatePresence mode="wait">
        {step === 1 && <PhoneInputForm onNext={(phone: string) => handleNext(2, phone)} />}
        {step === 2 && <CaptchaForm onNext={sendCode} />}
        {step === 3 && <CodeInputForm phone={phone} onNext={(num: number) => handleNext(num)} />}
        {step === 4 && <NewPasswordForm />}
      </AnimatePresence>
    </ChakraProvider>
  );
};
